// Lib
import { createSelector, createStructuredSelector } from 'reselect';

// Utils
import { createShallowSelector } from '../../utils/milanoteReselect/milanoteReselect';
import { getPhysicalId, getTextContent } from '../../../common/elements/utils/elementPropertyUtils';
import { getElement as getElementFromElements } from '../../../common/elements/utils/elementTraversalUtils';

// Selectors
import { getElement, getElements } from '../selectors/elementSelector';
import { getRenderedCloneElement } from './cloneUtils';

const originalElementIdSelector = () => createSelector(getElement, getPhysicalId);

const originalElementSelector = () =>
    createShallowSelector(getElements, originalElementIdSelector(), getElementFromElements);

const cloneRenderedElement = () => createSelector(getElement, originalElementSelector(), getRenderedCloneElement);

export default () =>
    createStructuredSelector({
        originalElementId: originalElementIdSelector(),
        originalElement: originalElementSelector(),
        renderedElement: cloneRenderedElement(),
    });

export const textContentSelector = (_state, { element }) => getTextContent(element);
